// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const comfey: PokeData = {
  "id": 764,
  "name": "comfey",
  "height": 1,
  "weight": 3,
  "base_experience": 170,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "bind",
    "vine-whip",
    "wrap",
    "leech-seed",
    "growth",
    "petal-dance",
    "sweet-kiss",
    "charm",
    "sweet-scent",
    "synthesis",
    "helping-hand",
    "aromatherapy",
    "magical-leaf",
    "natural-gift",
    "grass-knot",
    "petal-blizzard",
    "draining-kiss",
    "flower-shield",
    "grassy-terrain",
    "play-rough",
    "floral-healing"
  ],
  "moves": [
    "vine-whip",
    "sweet-kiss",
    "synthesis",
    "aromatherapy",
    "grassy-terrain",
    "play-rough",
    "mist-terrain",
    "dazzling-gleam",
    "heal-bell",
    "guardian-bond",
    "moonblast",
    "misty-terrain",
    "moonlight"
  ],
  "evolution_chain": {
    "id": 393,
    "item": null,
    "species": [
      {
        "name": "comfey",
        "order": 764,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 155,
    "ability_power": 127
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
